import { render, staticRenderFns } from "./ModalInserirRecurso.vue?vue&type=template&id=31e0263c"
import script from "./ModalInserirRecurso.vue?vue&type=script&lang=js"
export * from "./ModalInserirRecurso.vue?vue&type=script&lang=js"
import style0 from "./ModalInserirRecurso.vue?vue&type=style&index=0&id=31e0263c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports